<div class="mapLeafletOuter">
    <span class="markerLoading" *ngIf="markersLoading$()">Cerco le sedi</span>
    <div #mapLeaflet id="mapLeaflet" class="mapLeafletWrapper"></div>
</div>